import { Component, HostListener, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ADAuthService } from './KMLWeb_Shared/services/adauth.service';
import { Observable } from 'rxjs-compat';
import { DatePipe, PlatformLocation } from '@angular/common';
import { AdminServiceService } from './KMLWeb_Main/admin/admin.service';
import { environment } from '../environments/environment';
import { Store } from '@ngrx/store';
import { setmsalidtoken } from './store/counter.actions';
import { NgrxService } from './KMLWeb_Shared/services/ngrx.service';
import { Idle, EventTargetInterruptSource } from '@ng-idle/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  @HostListener('window:load', ['$event'])
  unloadHandler(event) {
    if (sessionStorage.getItem('msal.idtoken')) {
      if (sessionStorage.getItem('msal.idtoken') == '' || sessionStorage.getItem('msal.idtoken') == null) {
        localStorage.clear();
      }
    }
  }

  userRoles: any[] = [];
  userAssignRole: any[] = [];
  appDisable = false;
  idleState = 'Not started.';
  timedOut = false;
  private channel: BroadcastChannel;

  constructor(
    private location: PlatformLocation,
    private router: Router,
    public route: ActivatedRoute,
    private adAuthService: ADAuthService,
    private _datePipe: DatePipe,
    private adminservice: AdminServiceService,
    private ngrxService: NgrxService,
    private idle: Idle,
    private element: ElementRef
  ) {
    location.onPopState(() => {
      if (window.location.hash != '#/unsupported') {
        setTimeout(() => {
          if (sessionStorage.getItem('msal.idtoken')) {
            if (sessionStorage.getItem('msal.idtoken') == '' || sessionStorage.getItem('msal.idtoken') == null) {
              localStorage.clear();
              this.router.navigate(['/unauthorized']);
            }
          } else {
            localStorage.clear();
            this.router.navigate(['/unauthorized']);
          }
        }, 300);
      }
    });

    this.channel = new BroadcastChannel('token-refresh-channel');
    const Timeout = environment.idle_timer;
    this.idle.setIdle(1);  // Set idle time to 1 second
    this.idle.setTimeout(Timeout);
    this.idle.setInterrupts([new EventTargetInterruptSource(this.element.nativeElement, 'keydown mousemove mousedown mousewheel touchmove scroll')]);

    this.idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
    this.idle.onTimeout.subscribe(() => this.navigateToUnauthorized());
    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'Idle State Start!';
    });
    this.idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'currently idle';
    });

    this.reset();

    // Refresh token on a set interval (currently hardcoded)
    let interval = Observable.interval(environment.refreshtoken_timer).takeWhile(() => true).subscribe(() => {
      this.refreshToken();
    });
  }

  ngOnInit() {
    this.listenForTokenRefresh();
    this.detectBrowser();
  }

  ngOnDestroy() {
    // Clean up the BroadcastChannel when the component is destroyed
    this.channel.close();
  }

  ifLoggedIn() {
    let adToken: any;
    let ngrxstoreVal: any;
    ngrxstoreVal = this.ngrxService.getNgrxStoreVal();
    adToken = ngrxstoreVal.msalidtoken;
    return (adToken != undefined && adToken != "") ||
      window.location.href.indexOf('unauthorized') > -1 ||
      window.location.href.indexOf('unsupported') > -1;
  }

  detectBrowser() {
    const agent = window.navigator.userAgent.toLowerCase();

    var old_ie = agent.indexOf('msie');

    // This is for IE 11 and above
    var new_ie = agent.indexOf('trident/');

    if ((old_ie > -1) || (new_ie > -1) || (agent.indexOf('opr') > -1) && !!(<any>window).opr) {
      this.router.navigate(['/unsupported']);
    }
  }

  refreshToken() {
    const sessionKey = this.adAuthService.sessionkey;
    if (sessionKey != undefined) {
      this.adAuthService.generateNewToken().subscribe(data => {
        this.ngrxService.setmsalidtoken(data);
        if (data && data.accessToken) {
          sessionStorage.setItem('msal.idtoken', data.accessToken);
          }
        // Broadcast the token refresh event to other tabs
        this.channel.postMessage('refresh-token');
      });
    }
  }

  listenForTokenRefresh() {
    this.channel.onmessage = (message) => {
      if (message.data === 'refresh-token') {
        this.refreshToken();  // Trigger the refreshToken in the current tab
      }
    };
  }


  getCurrentUserwithRole() {
    this.adminservice.GetCurrentUserwithRole().subscribe(Response => {
      if (Response && Response != null) {
        this.userRoles = Response.userRoles;
        this.userRoles.forEach(value => {
          this.userAssignRole.push(value.role.name);
        });
        this.ngrxService.setuserAssignRole(JSON.stringify(this.userAssignRole));
        if (this.userAssignRole.length > 0) {
          if (this.userAssignRole.indexOf("BusinessAdmin") > -1) {
            console.log("User has all permissions.");
            this.appDisable = false;
          } else if (this.userAssignRole.indexOf("SupportUser") > -1) {
            this.appDisable = false;
          } else {
            this.appDisable = true;
          }
        } else {
          this.router.navigateByUrl("/unauthorized");
        }
      } else {
        this.router.navigateByUrl("/unauthorized");
      }
    });
  }

  // Reset the idle timer
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  // Navigate to the unauthorized page if the session times out
  navigateToUnauthorized() {
    this.timedOut = true;
    const navigationExtras: NavigationExtras = {
      queryParams: {
        errorMessage: environment.sessionTimoutMessage,
        userUnauthorizationMsgHide: true
      }
    };
    this.router.navigate(['/unauthorized'], { queryParams: navigationExtras.queryParams, relativeTo: this.route });
  }
}
